import Image from '@/components/Image';
import { useMediaQuery } from '@mui/material';
import React from 'react';

interface WhyChooseItem {
  image: string;
  title: string;
  title_m?: string;
  description: string;
  description_m?: string;
}

interface WhyChooseData {
  title: string;
  title_m?: string;
  data_array: WhyChooseItem[];
}

interface WhyChooseProps {
  whyChooseData: WhyChooseData;
}

const WhyChoose: React.FC<WhyChooseProps> = ({ whyChooseData = { title: '', data_array: [] } }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className="w-full py-[40px] px-[14px] mb-[46px] md:py-[56px] md:px-[180px] md:mb-0 box-border bg-[rgba(199,255,87,0.6)]">
      <div className="mb-[28px] md:mb-[48px]">
        <h2 className="text-[24px] md:text-[40px] font-bb text-center">{whyChooseData.title}</h2>
      </div>
      <ul className="flex flex-wrap justify-between gap-y-[20px] md:gap-y-0">
        {whyChooseData.data_array.map((item, index) => (
          <li
            key={index}
            className="w-[calc(50%-10px)] md:w-[calc(25%-15px)] flex flex-col items-center justify-start"
          >
            <Image
              src={item.image}
              alt={item.title_m || item.title}
              className="w-[46px] md:w-[4.3vw] h-auto block mb-[10px] md:mb-[20px]"
              width={46}
              height={46}
            />
            <h4 className="text-[13px] leading-[16px] md:text-[1.25vw] md:leading-normal font-bb text-center md:mb-[16px]">
              {item.title_m || item.title}
            </h4>
            {item.description && (
              <p className="text-[12px] leading-[14px] md:text-[0.83vw] md:leading-normal text-center mt-[8px] md:mt-0">
                {isMobile ? item.description_m : item.description}
              </p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WhyChoose;
